export const rightClickActionFilter = (action) => action.mouseButton === 2;
